// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e_IGwuthEx {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.e_IGwuthEx h4 {
  line-height: 3em;
}
.e_IGwuthEx .fHE69OhlhK {
  float: left;
  width: 100%;
}
.e_IGwuthEx .qWTHwnYvL0 {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.e_IGwuthEx .qWTHwnYvL0:hover {
  cursor: pointer;
}
.e_IGwuthEx .qWTHwnYvL0:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.K01VMHgTkw .osPQCYfR1v:focus {
  outline: none;
}
.K01VMHgTkw .osPQCYfR1v.tl1RiNLEdN.ZJig25mCzf {
  background: #375A88;
}
.K01VMHgTkw .osPQCYfR1v.tl1RiNLEdN.ZJig25mCzf span {
  color: #fff;
}
.K01VMHgTkw .ZJig25mCzf {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.K01VMHgTkw .ZJig25mCzf:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.K01VMHgTkw input {
  height: 38px;
  min-width: 220px;
}
.qWTHwnYvL0.Sg8m9HV3zy {
  background: #410102;
}
.qWTHwnYvL0.bgQwhl_KtL {
  background: #911318;
}
.qWTHwnYvL0._A7IuSbk4C {
  background: #D8293B;
}
.qWTHwnYvL0.HM5aXut5NR {
  background: #F2373C;
}
.qWTHwnYvL0.pdYVShEbbo {
  background: #FC4448;
}
.qWTHwnYvL0.QLk1kfz9ff {
  background: #ED535E;
}
.qWTHwnYvL0.B1s1QTXehd {
  background: #E34926;
}
.qWTHwnYvL0.mVhNUl3Adh {
  background: #FC562B;
}
.qWTHwnYvL0.VizqaoR7M3 {
  background: #FC6722;
}
.qWTHwnYvL0.HBGBTVcb1j {
  background: #FD7F24;
}
.qWTHwnYvL0.f5C_2jyYHC {
  background: #FD8D26;
}
.qWTHwnYvL0.VP_vEwRnC7 {
  background: #EC9C3E;
}
.qWTHwnYvL0.TXoKZFUBtP {
  background: #0e673a;
}
.qWTHwnYvL0.b4rmV0Y6gl {
  background: #208740;
}
.qWTHwnYvL0.lv6JTvQGMr {
  background: #239718;
}
.qWTHwnYvL0.kn8D4w64IT {
  background: #55A84D;
}
.qWTHwnYvL0.lKt3W3QVAA {
  background: #4BBE5A;
}
.qWTHwnYvL0.rFAkO5ECIv {
  background: #0CCA6A;
}
.qWTHwnYvL0.cIpDgBm_H9 {
  background: #0A3C64;
}
.qWTHwnYvL0.GeZDABxKSZ {
  background: #0d487a;
}
.qWTHwnYvL0.rDvo5iCc2i {
  background: #10538d;
}
.qWTHwnYvL0.KdhZS3Hd6m {
  background: #115A99;
}
.qWTHwnYvL0.K9eTMnAmKk {
  background: #3387E2;
}
.qWTHwnYvL0.tNPCIUWMc6 {
  background: #1BA9CF;
}
.qWTHwnYvL0.jRlKaIUamF {
  background: #d27c02;
}
.qWTHwnYvL0._L_7jUGwEV {
  background: #fb9402;
}
.qWTHwnYvL0.iwXfnTlpoq {
  background: #FD9B30;
}
.qWTHwnYvL0.pZgGvmiE78 {
  background: #FDBE2D;
}
.qWTHwnYvL0.TDz6U6P36u {
  background: #FED831;
}
.qWTHwnYvL0.Axi6u2ltrw {
  background: #FFFD38;
}
.qWTHwnYvL0.VgNAz5frxO {
  background: #2D215C;
}
.qWTHwnYvL0.CHg4b5_GHN {
  background: #483C83;
}
.qWTHwnYvL0.iR38XDjaVV {
  background: #58518d;
}
.qWTHwnYvL0.T7BCnB9yQO {
  background: #7068A9;
}
.qWTHwnYvL0.VWrkV9avjR {
  background: #7f78b2;
}
.qWTHwnYvL0.NYD2m1FhKy {
  background: #8f88bc;
}
.qWTHwnYvL0.MceUOjaEDm {
  background: #000;
}
.qWTHwnYvL0.tYDYFGC5NT {
  background: #282626;
}
.qWTHwnYvL0.P1kyJhjZ9U {
  background: #242222;
}
.qWTHwnYvL0.pYnEDlDHbS {
  background: #353838;
}
.qWTHwnYvL0.ioKeVTsWXZ {
  background: #666;
}
.qWTHwnYvL0.vKhPI9t24K {
  background: #999;
}
.xYboC702dY {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.xYboC702dY .dKnTnuEAYs {
  display: none;
}
.ZeHQP3d65A {
  padding: 16px 16px 14px 16px;
  margin-bottom: 0 !important;
}
.ZeHQP3d65A .bUUVNFls51 {
  min-height: 50px;
}
.ZeHQP3d65A .bUUVNFls51 .ESPljksMvc {
  display: flex;
  align-items: baseline;
  width: 87%;
}
.ZeHQP3d65A .CjaqLBoqKs {
  border-bottom: none;
  padding-bottom: 0;
}
.ZeHQP3d65A .CjaqLBoqKs .XPQQHqYjVG {
  margin-top: 0;
}
.ZeHQP3d65A .CjaqLBoqKs .XPQQHqYjVG .wUDu1NEuTZ .oPuYuu41Ot {
  display: block;
}
.ZeHQP3d65A .CjaqLBoqKs .XPQQHqYjVG:first-child {
  border-radius: 4px 4px 0 0;
}
.ZeHQP3d65A .CjaqLBoqKs .XPQQHqYjVG:last-child {
  border-radius: 0 0 4px 4px;
}
.ZeHQP3d65A .R4ARd60z8O.R4ARd60z8O {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
}
.ZeHQP3d65A .aaAgQk2WOE.aaAgQk2WOE {
  background-color: #027391;
}
.ZeHQP3d65A .aaAgQk2WOE.aaAgQk2WOE:hover {
  background-color: #027391;
}
.ZeHQP3d65A .Od59uNdtQm {
  display: flex;
}
.ZeHQP3d65A .kWkwjuxv8v {
  border-radius: 4px;
  padding: 4px 12px;
}
.ZeHQP3d65A .zWTZtZABze {
  background-color: #fff;
  border-radius: 4px;
  color: #000000;
  height: 24px;
  width: 24px;
}
.ZeHQP3d65A .QnIpnR9TVz.QnIpnR9TVz {
  background-color: #ccc;
  color: #000000;
  font-weight: 400;
}
.e3SPHdwJKY:not(:last-child) {
  margin: 0;
}
.e3SPHdwJKY:not(:last-child)::after {
  content: '';
  display: block;
  border-bottom: 1px solid #fff;
  height: 1px;
  width: 100%;
  position: relative;
}
.e3SPHdwJKY:last-child {
  visibility: hidden;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `e_IGwuthEx`,
	"color-row": `fHE69OhlhK`,
	"color-tile": `qWTHwnYvL0`,
	"picker-component": `K01VMHgTkw`,
	"picker-element": `osPQCYfR1v`,
	"active": `tl1RiNLEdN`,
	"btn": `ZJig25mCzf`,
	"red-1": `Sg8m9HV3zy`,
	"red-2": `bgQwhl_KtL`,
	"red-3": `_A7IuSbk4C`,
	"red-4": `HM5aXut5NR`,
	"red-5": `pdYVShEbbo`,
	"red-6": `QLk1kfz9ff`,
	"orange-1": `B1s1QTXehd`,
	"orange-2": `mVhNUl3Adh`,
	"orange-3": `VizqaoR7M3`,
	"orange-4": `HBGBTVcb1j`,
	"orange-5": `f5C_2jyYHC`,
	"orange-6": `VP_vEwRnC7`,
	"green-1": `TXoKZFUBtP`,
	"green-2": `b4rmV0Y6gl`,
	"green-3": `lv6JTvQGMr`,
	"green-4": `kn8D4w64IT`,
	"green-5": `lKt3W3QVAA`,
	"green-6": `rFAkO5ECIv`,
	"blue-1": `cIpDgBm_H9`,
	"blue-2": `GeZDABxKSZ`,
	"blue-3": `rDvo5iCc2i`,
	"blue-4": `KdhZS3Hd6m`,
	"blue-5": `K9eTMnAmKk`,
	"blue-6": `tNPCIUWMc6`,
	"yellow-1": `jRlKaIUamF`,
	"yellow-2": `_L_7jUGwEV`,
	"yellow-3": `iwXfnTlpoq`,
	"yellow-4": `pZgGvmiE78`,
	"yellow-5": `TDz6U6P36u`,
	"yellow-6": `Axi6u2ltrw`,
	"purple-1": `VgNAz5frxO`,
	"purple-2": `CHg4b5_GHN`,
	"purple-3": `iR38XDjaVV`,
	"purple-4": `T7BCnB9yQO`,
	"purple-5": `VWrkV9avjR`,
	"purple-6": `NYD2m1FhKy`,
	"black-1": `MceUOjaEDm`,
	"black-2": `tYDYFGC5NT`,
	"black-3": `P1kyJhjZ9U`,
	"black-4": `pYnEDlDHbS`,
	"black-5": `ioKeVTsWXZ`,
	"black-6": `vKhPI9t24K`,
	"picker-theme": `xYboC702dY`,
	"arrow-regular": `dKnTnuEAYs`,
	"comment__root": `ZeHQP3d65A`,
	"comment__content--container": `bUUVNFls51`,
	"comment__content--header": `ESPljksMvc`,
	"comment__content--root": `CjaqLBoqKs`,
	"child-comment--root": `XPQQHqYjVG`,
	"child-comment__content--container": `wUDu1NEuTZ`,
	"child-comment__content--header": `oPuYuu41Ot`,
	"comment--avatar": `R4ARd60z8O`,
	"comment__reply-btn": `aaAgQk2WOE`,
	"comment__secondary-action": `Od59uNdtQm`,
	"ziflow-activity__open-btn": `kWkwjuxv8v`,
	"comment__open-btn": `zWTZtZABze`,
	"add-attachment--btn": `QnIpnR9TVz`,
	"comment--divider": `e3SPHdwJKY`
};
export default ___CSS_LOADER_EXPORT___;
